import { useMemo } from "react";
import { formatFriendlyDistanceToNow } from "src/utils/time";

export const useLastRanAtFriendly = ({
  runAt,
  hidePrefix = false,
}: {
  runAt: Date | null;
  hidePrefix?: boolean;
}) => {
  const runAtFriendly = useMemo(() => {
    if (runAt == null || Number.isNaN(runAt.getTime())) {
      return "Never refreshed";
    }
    const distance = formatFriendlyDistanceToNow(runAt.toISOString());
    return hidePrefix ? distance : `Last refreshed ${distance.toLowerCase()}`;
  }, [runAt, hidePrefix]);

  return runAtFriendly;
};
